import React, { Component } from "react";
import bgImage from "../../../../src/img/full-page-bg.jpg";

export class Headers extends Component {
  render() {
    return (
      <div className="request-header">
        <img
          className="request-header-bgLogo"
          src={bgImage}
          alt="background-img"
        />
        <h1 className="request-header-title">{this.props.title}</h1>
      </div>
    );
  }
}